import { Loader } from "@circle-react-shared/uikit/Loader";

export const PageLoader = () => (
  <div className="flex size-full items-center justify-center">
    <Loader />
  </div>
);
